import getJsonLdScriptId from "@insite/client-framework/Common/Utilities/getJsonLdScriptId";
import { Metadata } from "@insite/client-framework/Common/Utilities/setPageMetadata";
import { Handler } from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, LookUpData } from "@insite/client-framework/Store/CommonHandlers/SetMetadata";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getAlternateLanguageUrls, getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { WebsiteSettingsModel } from "@insite/client-framework/Types/ApiModels";
import { AdminCustomSettings } from "@tCooneyBrothers/ApiModels";
import { Website } from "@insite/client-framework/Services/WebsiteService";


type HandlerType = Handler<{}, { metadata?: Metadata; websiteSettings?: WebsiteSettingsModel; website?: Website }>;

export const LookUpDataExtended: HandlerType = props => {
    const state = props.getState();
    const page = getCurrentPage(state);

    const pathname = state.data.pages.location.pathname;
    const alternateLanguageUrls = getAlternateLanguageUrls(state, page.id);
    const websiteName = state.context.website.name;
    const adminCustomSettings = getSettingsCollection(state).adminCustomSettings as AdminCustomSettings;

    let useMetaKeywords = page.fields.metaKeywords;
    if (adminCustomSettings && !adminCustomSettings.useMetaKeywordsOnStaticPages) {
        useMetaKeywords = "";
    }

    props.metadata = {
        metaKeywords: useMetaKeywords,
        metaDescription: page.fields.metaDescription,
        openGraphUrl: page.fields.openGraphUrl,
        openGraphTitle: page.fields.openGraphTitle,
        openGraphImage: page.fields.openGraphImage,
        title: page.fields["browserPageTitle"] || page.fields.title,
        currentPath: pathname,
        canonicalPath: pathname,
        alternateLanguageUrls,
        websiteName,
        jsonLdScriptId: getJsonLdScriptId(page.type),
        pageType: page.type,
    };
    props.websiteSettings = getSettingsCollection(state).websiteSettings;
    props.website = state.context.website;
};

replaceInChain(chain, LookUpData, LookUpDataExtended);
